import { Group } from "@mantine/core";
import BlacklistsExclusion from "./BlacklistsExclusion";
import SentCampaignExclusion from "./SentCampaignExclusion";

const CampaignExclusion = ({ programData, setProgramData }) => {
  return (
    <Group
      wrap="nowrap"
      w={"100%"}
      h={520}
      justify="space-between"
      align="stretch"
      gap={"xl"}
    >
      <BlacklistsExclusion
        programData={programData}
        setProgramData={setProgramData}
      />

      <SentCampaignExclusion
        programData={programData}
        setProgramData={setProgramData}
      />
    </Group>
  );
};

export default CampaignExclusion;
